import React from "react";
import { Box, Stack } from "@mui/material";
import { ParlorDetailProps } from "../../../types";
import { GOI_WEB_URL } from "../../../constants";
export function ATypeFAQ({
  defaultParlor,
}: {
  defaultParlor: ParlorDetailProps;
}) {
  const isGongsul = defaultParlor.managed_type === "공설";
  const parkCnt = Number(defaultParlor.amenities?.parkcnt) || 0;

  return (
    <Stack gap="10px" padding="40px 20px">
      <h2 className="subtitle_16_b">자주 묻는 질문</h2>
      <Stack gap="32px">
        <Stack gap="4px">
          <Box className="subtitle_14_b gray900">
            {defaultParlor.companyname}의 경우 영업 시간이 언제인가요?
          </Box>
          <Box className="body_14_m gray700">
            {defaultParlor.companyname}의 영업시간은 00:00 ~ 24:00입니다.
          </Box>
        </Stack>
        <Stack gap="4px">
          <Box className="subtitle_14_b gray900">
            {defaultParlor.companyname} 이용 시 비용은 얼마인가요?
          </Box>
          <Box className="body_14_m gray700">
            {defaultParlor.companyname} 빈소 비용은 최소{" "}
            {Math.round(defaultParlor.binsos[0].charge / 10000)}
            만원부터 시작합니다.
          </Box>
        </Stack>
        {isGongsul && (
          <>
            <Stack gap="4px">
              <Box className="subtitle_14_b gray900">
                {defaultParlor.companyname}의 주차 안내는 어떻게 되나요?
              </Box>
              <Box className="body_14_m gray700">
                공설 장례식장 특성상 주차 공간이 협소한 편입니다
                {parkCnt > 0 && parkCnt < 10 ? ` (전용 ${parkCnt}대)` : ""}. 조문객에게 대중교통 이용을 함께 안내드리는 것을 권장합니다.
              </Box>
            </Stack>
            <Stack gap="4px">
              <Box className="subtitle_14_b gray900">
                공설 장례식장의 특성은 무엇인가요?
              </Box>
              <Box className="body_14_m gray700">
                {defaultParlor.companyname}은 공설 장례식장으로, 비용 체계가 공개적이며 지자체 연계로 안정 운영됩니다. 의료원 부설인 경우 임종-안치 동선이 유리합니다. 다만 매점이나 유족 대기실이 별도 지정되지 않은 경우가 있으므로 시설 안내를 미리 확인하세요.
              </Box>
            </Stack>
          </>
        )}
      </Stack>
    </Stack>
  );
}
